import React from 'react';
import * as styles from './preview-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var PreviewCard = _ref => {
  var article = _ref.article,
    _ref$useIndexHeadline = _ref.useIndexHeadline,
    useIndexHeadline = _ref$useIndexHeadline === void 0 ? false : _ref$useIndexHeadline,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '' : _ref$target,
    _ref$rel = _ref.rel,
    rel = _ref$rel === void 0 ? '' : _ref$rel;
  var _article$image = article.image,
    image = _article$image === void 0 ? '' : _article$image,
    _article$url = article.url,
    url = _article$url === void 0 ? '' : _article$url,
    _article$title = article.title,
    title = _article$title === void 0 ? null : _article$title,
    _article$indexHeadlin = article.indexHeadline,
    indexHeadline = _article$indexHeadlin === void 0 ? null : _article$indexHeadlin,
    linkCategory = article.linkCategory;
  var articleTitle = useIndexHeadline ? indexHeadline : title;
  return ___EmotionJSX("div", {
    css: styles.articleCard
  }, ___EmotionJSX("div", {
    css: styles.content
  }, image && ___EmotionJSX("div", {
    css: styles.leftImageContainer
  }, ___EmotionJSX("a", {
    href: url,
    css: styles.link,
    target: target,
    rel: rel,
    onClick: onClick,
    "aria-label": title || ''
  }, ___EmotionJSX("img", {
    src: image,
    alt: ""
  }))), ___EmotionJSX("div", {
    css: styles.middle
  }, linkCategory && ___EmotionJSX("div", {
    css: styles.category
  }, linkCategory), articleTitle && ___EmotionJSX("a", {
    href: url,
    css: styles.link,
    target: target,
    rel: rel,
    onClick: onClick
  }, ___EmotionJSX("h3", {
    css: styles.heading,
    className: "title"
  }, articleTitle)))));
};
export default PreviewCard;